var map = {
	"./game1/level1/0.png": "153a",
	"./game1/level1/1.png": "f257",
	"./game1/level1/2.png": "215d",
	"./game1/level1/3.png": "0a74",
	"./game1/level1/4.png": "8898",
	"./game1/level1/5.png": "5c9f",
	"./game1/level1/6.png": "87cb",
	"./game1/level1/7.png": "82e3",
	"./game1/level2/0.png": "a536",
	"./game1/level2/1.png": "7f84",
	"./game1/level2/2.png": "3e21",
	"./game1/level2/3.png": "6ba9",
	"./game1/level2/4.png": "205b",
	"./game1/level2/5.png": "d85e",
	"./game1/level2/6.png": "b0ec",
	"./game1/level2/7.png": "13d3",
	"./game1/level3/0.png": "015a",
	"./game1/level3/1.png": "6487",
	"./game1/level3/2.png": "ad4c",
	"./game1/level3/3.png": "4c23",
	"./game1/level3/4.png": "9830",
	"./game1/level3/5.png": "bcb7",
	"./game1/level3/6.png": "cc0b",
	"./game1/level3/7.png": "736e",
	"./game2/level1/0.png": "9370",
	"./game2/level1/1.png": "76bb",
	"./game2/level1/2.png": "8147",
	"./game2/level1/3.png": "9dcb",
	"./game2/level1/4.png": "9e0c",
	"./game2/level1/5.png": "0c1d",
	"./game2/level1/6.png": "8b79",
	"./game2/level1/7.png": "96db",
	"./game2/level2/0.png": "0deb",
	"./game2/level2/1.png": "981a",
	"./game2/level2/2.png": "e028",
	"./game2/level2/3.png": "8a11",
	"./game2/level2/4.png": "1e06",
	"./game2/level2/5.png": "ee12",
	"./game2/level2/6.png": "1632",
	"./game2/level2/7.png": "4ab2",
	"./game2/level3/0.png": "673e",
	"./game2/level3/1.png": "a846",
	"./game2/level3/2.png": "2c3e",
	"./game2/level3/3.png": "7841",
	"./game2/level3/4.png": "ee8c",
	"./game2/level3/5.png": "a9b6",
	"./game2/level3/6.png": "205c",
	"./game2/level3/7.png": "29e8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a956";